import { createSlice } from '@reduxjs/toolkit';

import { getNewOrdersData, confirmNewOrder } from '../../apis';

export const NewOrdersSlice = createSlice({
    name: 'newOrders',
    initialState: {
        newOrderIsLoading: false,
        data : [],
        confirmOrderIsLoading: false,
        error: ''
    },

    reducers: {
        updateStyleRowData: (state, action) => {
            return {
                ...state,
                data: {
                    ...state.data,
                    new_orders: [...(state.data.new_orders.filter(item => item.style_id !== action.payload.style_id)), action.payload]
                }
            }
        },
    },

    extraReducers: (builder) => {
        builder.addCase(getNewOrdersData.pending, (state, action) => {
            state.newOrderIsLoading = true;
        })
        builder.addCase(getNewOrdersData.fulfilled, (state, action) => {
            state.error = '';
            state.newOrderIsLoading = true;
            state.data = action.payload.data
        })
        builder.addCase(getNewOrdersData.rejected, (state, action) => {
            state.error = action.payload.message
            state.newOrderIsLoading = false;
        })
        builder.addCase(confirmNewOrder.pending, (state, action) => {
            state.confirmOrderIsLoading = true;
        })
        builder.addCase(confirmNewOrder.fulfilled, (state, action) => {
            state.error = '';
            state.confirmOrderIsLoading = true;
        })
        builder.addCase(confirmNewOrder.rejected, (state, action) => {
            state.error = action.payload.message
            state.confirmOrderIsLoading = false;
        })
    }
})

export const { updateStyleRowData } = NewOrdersSlice.actions

export default NewOrdersSlice.reducer